export enum SpecialDescriptor {
  RoyalBlue = 'Royal Blue',
  CornflowerBlue = 'Cornflower Blue',
  Blue = 'Blue',
  VividBlue = 'Vivid Blue',
  Padparadscha = 'Padparadscha',
  PigeonBloodRed = 'Pigeon Blood Red',
  RoyalRed = 'Royal Red',
  VividRed = 'Vivid Red',
  HotPink = 'Hot Pink',
  VividPink = 'Vivid Pink',
  CanaryYellow = 'Canary Yellow',
  VividYellow = 'Vivid Yellow',
  LavenderViolet = 'Lavender Violet',
  VividViolet = 'Vivid Violet',
  VividPurple = 'Vivid Purple',
  Teal = 'Teal',
  GoldenOrange = 'Golden Orange',
  GoldenYellow = 'Golden Yellow',
  Peach = 'Peach',
  Nil = 'Nil',
}
